import { z } from '@hono/zod-openapi'
import { signupAccessControlTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertSignupAccessControl = z.infer<
    typeof zInsertSignupAccessControl
>
export type SelectSignupAccessControl = z.infer<
    typeof zSelectSignupAccessControl
>
export type UpdateSignupAccessControl = z.infer<
    typeof zUpdateSignupAccessControl
>
export type QuerySignupAccessControl = z.infer<typeof zQuerySignupAccessControl>
export type ColumnsOfSignupAccessControlTable =
    keyof typeof signupAccessControlTable._.columns

export const zSelectSignupAccessControl = createSelectSchema(
    signupAccessControlTable,
)
export const zInsertSignupAccessControl = createInsertSchema(
    signupAccessControlTable,
).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateSignupAccessControl = zInsertSignupAccessControl.partial()
export const zQuerySignupAccessControl = zInsertSignupAccessControl
    .extend({
        id: z.string(),
        ids: z.string().array(),
        isBlocked: z.string().default('false'),
    })
    .extend(zCommonQuery.shape)
    .partial()
